import {
    Box,
    Chip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import React from 'react';
import { SaleStatement } from '../../models/contract/SaleStatement';
import { toIndoFormat } from '../../utils/helper';

interface ChildContractsListProps {
    children: { statement: SaleStatement }[];
}

const ChildContractsList: React.FC<ChildContractsListProps> = ({ children }) => {
    if (!children || children.length === 0) return null;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {children.map((child, index) => (
                <Box
                    key={child.statement.id ?? index}
                    sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1.5, bgcolor: 'background.default' }}>
                        <Typography variant="body2" fontWeight="bold">
                            Statement #{child.statement.id}
                        </Typography>
                        {child.statement.total != null && (
                            <Chip
                                label={`${toIndoFormat(child.statement.total)} Rp`}
                                size="small"
                                color="primary"
                                variant="outlined"
                            />
                        )}
                    </Box>

                    <Divider />

                    {child.statement.line_items && child.statement.line_items.length > 0 ? (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Item</TableCell>
                                    <TableCell align="right">Qty (kg)</TableCell>
                                    <TableCell align="right">Price/kg (Rp)</TableCell>
                                    <TableCell align="right">Total (Rp)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {child.statement.line_items.map((item, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{item.title ?? item.sku}</TableCell>
                                        <TableCell align="right">{item.quantity}</TableCell>
                                        <TableCell align="right">{toIndoFormat(item.price_per_unit)}</TableCell>
                                        <TableCell align="right">{toIndoFormat(item.total)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <Box sx={{ px: 2, py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary">
                                No line items
                            </Typography>
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default ChildContractsList;
